import React, { ReactElement } from "react";
import { IconSvg } from "../../icon/icon-svg";

export const IconThumbUp = ({ ...svgAttrs }): ReactElement => (
  <IconSvg style={{ fill: "#fff" }} {...svgAttrs}>
    <path
      d="M14.4545 11.6364C15.0575 11.6364 15.5455 12.1258 15.5455 12.7273C15.5455 13.3302 15.0575 13.8182 14.4545 13.8182H13.7273C14.3302 13.8182 14.8182 14.3076 14.8182 14.9091C14.8182 15.512 14.3302 16 13.7273 16H9C6.09091 16 6.81818 14.5455 1 14.5455V8H3.18182C5.72727 8 8.63636 5.65673 8.63636 2.18182C8.63636 1.032 10.8182 0.886546 10.8182 3.06836C10.8182 4.52291 10.0909 7.27273 10.0909 7.27273H15.9091C16.512 7.27273 17 7.76218 17 8.36364C17 8.96655 16.512 9.45455 15.9091 9.45455H15.1818C15.7847 9.45455 16.2727 9.944 16.2727 10.5455C16.2727 11.1484 15.7847 11.6364 15.1818 11.6364H14.4545Z"
      stroke="#121315"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconSvg>
);
